<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-toolbar class="elevation-1">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <template>
                <v-btn
                        color="primary"
                        class="ma-0"
                        min-width="0"
                        to="/work-hours/create"
                >
                    <v-icon>add</v-icon>
                </v-btn>

            </template>
        </v-toolbar>

        <FormCard :title="$t('general.search_form')">
            <template v-slot:form>
                <v-form autocomplete="off">
                    <v-row dense>
                        <!-- Selects -->
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <!-- Developer select -->
                            <v-select class="custom_textfield"
                                      :items="select_field_developers"
                                      v-model="search_options.developer_id"
                                      :label="$t('general.developer')"
                                      type="select"
                                      item-text="name"
                                      item-value="id"
                                      outlined
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <v-select class="custom_textfield"
                                      :label="$t('general.client')"
                                      type="select"
                                      :items="select_field_clients"
                                      v-model="search_options.client_id"
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      @change="getSelectFieldProjects($event)"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <v-select
                                    class="custom_textfield"
                                    :label="$t('general.project')"
                                    type="select"
                                    :items="select_field_projects"
                                    v-model="search_options.project_id"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                            ></v-select>
                        </v-col>
                        <!-- Date pickers -->
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <!-- Start date input -->
                            <v-menu v-model="start_time_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field class="custom_textfield"
                                                  v-model="computedStartDateFormatted"
                                                  :label="$t('general.from')"
                                                  append-icon="event"
                                                  readonly
                                                  v-on="on"
                                                  outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="search_options.start_time"
                                               @input="start_time_picker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <!-- End date input-->
                            <v-menu v-model="end_time_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field class="custom_textfield"
                                                  v-model="computedEndDateFormatted"
                                                  :label="$t('general.to')"
                                                  append-icon="event"
                                                  readonly
                                                  v-on="on"
                                                  outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="search_options.end_time"
                                               @input="end_time_picker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <!-- Checkboxes -->
                        <v-col cols="6" sm="4" md="3" lg="2">
                            <v-checkbox class="custom_checkbox"
                                        v-model="search_options.billable"
                                        :label="`${$t('workHours.billable_hours')}`">
                            </v-checkbox>


                        </v-col>
                        <v-col cols="6" sm="4" md="3" lg="2">
                            <v-checkbox class="custom_checkbox"
                                        v-model="search_options.invoiced"
                                        :label="`${$t('workHours.invoiced_hours')}`">
                            </v-checkbox>
                        </v-col>
                        <v-col cols="6" sm="4" md="3" lg="2">
                            <v-checkbox class="custom_checkbox"
                                        v-model="search_options.paid"
                                        :label="`${$t('workHours.paid_hours')}`">
                            </v-checkbox>
                        </v-col>
                        <!-- Refresh button -->
                        <v-col cols="12" sm="12" md="3" lg="6" class="text-right">
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                   @click="resetForm"
                            >
                                {{$t('general.reset_form')}}
                                <v-icon right>refresh</v-icon>

                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </FormCard>

        <v-container fluid class="work_hours_container">
            <v-row dense class="mb-2">
                <!-- Total work hours -->
                <v-chip class="ma-1"
                        label
                        color="primary"
                >
                    {{$t('general.work_hours_sum')}}: {{work_hours_sum}}
                </v-chip>
                <!--Print work hours button-->
                <v-btn class="ma-1"
                       @click="printSelectedTrigger"
                       color="primary"
                       :disabled="selected_items.length === 0"
                >
                    <v-icon>print</v-icon>
                </v-btn>
            </v-row>
            <ResponsiveDataTable :loading="dTableLoading"
                                 :headers="dTableHeaders"
                                 :items="dTableData"
                                 :enableSearch="false"
                                 :totalItems="dTableTotalItems"
                                 :mobileBreakpoint="960"
                                 :itemsPerPageOptions="[20,50,100,-1]"
                                 sortByColumn="3"
                                 :isDescending="true"
                                 :selectedItems="selected_items"
                                 @options-changed="optionsChanged"
                                 @selected-changed="selectedChanged"
            >
                <!-- Set actions -->
                <template v-slot:actions="slotProps">
                    <v-icon v-if="update_permission && slotProps.item.user_active && slotProps.item.project_active"
                            class="material-icons edit_icon action_icon"
                            color="primary"
                            @click="editItemTrigger(slotProps.item)"
                    > edit
                    </v-icon>
                    <v-icon v-if="repeat_permission && slotProps.item.user_active && slotProps.item.project_active"
                            class="material-icons repeat_icon action_icon"
                            color="primary"
                            @click="repeatItemTrigger(slotProps.item)"
                    > repeat
                    </v-icon>
                    <v-icon v-if="delete_permission"
                            class="material-icons delete_icon action_icon"
                            color="error"
                            @click="deleteItemTrigger(slotProps.item)"
                    > delete
                    </v-icon>
                </template>

                <!-- Payment options -->
                <template v-slot:billable="slotProps">
                    <i v-if="slotProps.item.billable === 1"
                       class="material-icons payment_icon">
                        done
                    </i>
                    <i class="material-icons payment_icon"
                       v-else
                    >
                        close
                    </i>
                </template>
                <template v-slot:invoiced="slotProps">
                    <i v-if="slotProps.item.invoiced === 1"
                       class="material-icons payment_icon">
                        done
                    </i>
                    <i class="material-icons payment_icon"
                       v-else
                    >
                        close
                    </i>
                </template>
                <template v-slot:paid="slotProps">
                    <i v-if="slotProps.item.paid === 1"
                       class="material-icons payment_icon">
                        done
                    </i>
                    <i class="material-icons payment_icon"
                       v-else
                    >
                        close
                    </i>
                </template>
            </ResponsiveDataTable>
        </v-container>

        <!-- Confirm action dialog -->
        <ConfirmActionDialog :dialog="confirmDialog"
                             :header="confirmDialogHeader"
                             :message="confirmDialogMessage"
                             :color="confirmDialogColor"
                             :styleClass="confirmDialogClass"
                             :action="confirm_action"
                             @close="closeConfirmDialog"
                             @delete="deleteItemConfirmed"
        ></ConfirmActionDialog>
    </div>
</template>

<script>
    import FormCard from '../components/FormCard.vue'
    import ResponsiveDataTable from '../components/ResponsiveDataTable.vue'
    import ConfirmActionDialog from '../components/ConfirmActionDialog.vue'

    export default {
        components: {
            FormCard,
            ResponsiveDataTable,
            ConfirmActionDialog
        },
        props: {
            title: {
                type: String
            }
        },
        computed: {
            computedStartDateFormatted() {
                return this.search_options.start_time ? this.moment(this.search_options.start_time).format('DD/MM/YYYY') : ''
            },
            computedEndDateFormatted() {
                return this.search_options.end_time ? this.moment(this.search_options.end_time).format('DD/MM/YYYY') : ''
            }
        },
        data() {
            return {
                current_user: this.$store.state.user,
                // Search form
                search_options: {
                    developer_id: null,
                    client_id: null,
                    project_id: null,
                    start_time: this.moment().startOf('month').format('YYYY-MM-DD'),
                    end_time: this.moment().format('YYYY-MM-DD'),
                    billable: false,
                    invoiced: false,
                    paid: false,
                },
                search_criteria: {},
                start_time_picker: false,
                end_time_picker: false,
                select_field_developers: [],
                select_field_clients: [],
                select_field_projects: [],

                // Data table
                dTableLoading: false,
                dTableHeaders: [
                    {
                        text: `${this.$t('general.developer')}`,
                        value: 'developer',
                        sortable: true,
                    },
                    {
                        text: `${this.$t('general.client')}`,
                        value: 'client',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.project')}`,
                        value: 'project',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.date')}`,
                        value: 'start_time',
                        sortable: true,
                    },
                    {
                        text: `${this.$t('general.start')}`,
                        value: 'start',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.stop')}`,
                        value: 'end',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.hours')}`,
                        value: 'duration',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.description')}`,
                        width: '20%',
                        value: 'description',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('workHours.billable_hours')}`,
                        class: 'header_icon',
                        value: 'billable',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('workHours.invoiced_hours')}`,
                        class: 'header_icon',
                        value: 'invoiced',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('workHours.paid_hours')}`,
                        class: 'header_icon',
                        value: 'paid',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.actions')}`,
                        value: 'actions',
                        align: 'right',
                        class: 'actions_header',
                        sortable: false,
                    },

                ],
                dTableData: [],
                dTableTotalItems: 0,
                dTableOptions: {
                    page: null,
                    itemsPerPage: null,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false
                },
                work_hours_sum: 0,
                selected_items: [],

                // Confirmation dialog
                current_item_id: null, // id of selected item
                confirm_action: null,
                confirmDialog: false,
                confirmDialogColor: null,
                confirmDialogHeader: null,
                confirmDialogMessage: null,
                confirmDialogClass: null,

                // Permissions
                delete_permission: false,
                update_permission: false,
                repeat_permission: false
            }
        },
        methods: {
            // Get all developers for the select field
            async getSelectFieldDevelopers() {
                // Get all users
                this.select_field_developers = (await this.$store.dispatch('fetchData', {
                    url: '/api/users/devs'
                }))[0];

                // Select developer
                if (this.select_field_developers.length === 1) {
                    this.search_options.developer_id = this.select_field_developers[0].id;
                }
            },
            // Get all clients and their projects for the select field
            async getSelectFieldClients() {
                this.select_field_clients = (await this.$store.dispatch('fetchData', {url: '/api/clients/all'}))[0];

                this.select_field_clients.forEach(client => {
                        client.projects.forEach(project => this.select_field_projects.push(project));
                    }
                );
            },
            // When a Client is selected find the projects associated with him to set in projects drop down
            getSelectFieldProjects(client_id) {
                // Find currently selected client in clients list
                const selected_client = this.select_field_clients.find(client => client.id === client_id);

                // Get selected client's projects for projects select fields
                this.select_field_projects = selected_client.projects;

                // Set client's first project as default select field option
//                if (selected_client.projects.length > 0) {
//                    // Set default selected project.
//                    this.search_options.project_id = selected_client.projects[0].id;
//                }
            },
            // Update selected work hours
            selectedChanged(selected) {
                this.selected_items = selected;
                let total = 0;
                selected.forEach(item => total += Number(item.duration));
                this.work_hours_sum = total.toFixed(2);
            },
            // Build print page and action
            printSelectedTrigger() {
                let newWin = window.open("");

                // Build print page header
                let header = `<header style="margin-bottom:25px;">
								<div class="header" style="padding-top:15px;padding-bottom:15px;">
									<img id="logo_img" alt="">
								</div>
							  </header>`;

                // Build print page table head
                let table_head = `<thead>
										<tr>
											<th align="left">${this.$t('general.project')}</th>
											<th align="left">${this.$t('general.description')}</th>
											<th>${this.$t('general.date')}</th>
											<th align="right">${this.$t('general.start')}</th>
											<th align="right">${this.$t('general.stop')}</th>
											<th align="right">${this.$t('general.hours')}</th>
										<tr>
									</thead>`;

                // Build print page table body for print
                let table_data = '<tbody>';
                if (this.selected_items) {
                    this.selected_items.forEach(item => {
                        table_data += '<tr>';
                        table_data += `<td>${item.project}</td>`;
                        table_data += `<td>${item.description ? item.description : ''}</td>`;
                        table_data += `<td align="right">${item.start_time}</td>`;
                        table_data += `<td align="right">${item.start}</td>`;
                        table_data += `<td align="right">${item.end}</td>`;
                        table_data += `<td align="right">${item.duration}</td>`;
                        table_data += '</tr>';
                    });
                    table_data += '</tbody>';
                }

                // Html print page content
                newWin.document.write(`<html>
									    <head><title>hLog</title></head>
									    <body>
									        ${header}
									        <table id="data_table" style="width:100%">
									            ${table_head}
									            ${table_data}
									        </table>
									        <span style="float:right;font-weight:bold;padding-top:15px">
												${this.$t('general.work_hours_sum')}: ${this.work_hours_sum}
											</span>
										</body>
									   </html>`);

                let img = newWin.document.getElementById("logo_img");
                img.src = require('@/assets/logo_bluchip.png');

                // Give style to table
                let elements = newWin.document.querySelectorAll('#data_table tbody tr td');
                elements.forEach(el => {
                    el.style['border-bottom'] = '1px solid #ddd';
                    el.style['height'] = '32px';
                });

                setTimeout(() => {
                    newWin.print();
                    newWin.close();
                }, 50);
            },
            // Reset the form data
            resetForm() {

                for (let prop in this.search_options) {
                    this.search_options[prop] = (prop === 'start_time') ? this.moment().startOf('month').format('YYYY-MM-DD')
                        : (prop === 'end_time') ? this.moment().format('YYYY-MM-DD')
                            : (['billable', 'invoiced', 'paid'].indexOf(prop) > -1) ? false : null;
                }

                this.selected_items = [];
                this.work_hours_sum = 0;
                this.getSelectFieldClients();
            },
            // Request API for data table data
            async fetchTableData() {
                // clear selected items and work hours sum
                this.selected_items = [];
                this.work_hours_sum = 0;

                // Set date and time criteria
                this.search_criteria.start_time = `${this.search_options.start_time} 00:00:00`;
                this.search_criteria.end_time = `${this.search_options.end_time} 23:59:59`;

                let response = await this.$store.dispatch('fetchData', {
                    url: `/api/work-hours`,
                    params: {
                        search_options: this.search_criteria,
                        table_options: this.dTableOptions,
                    }
                });

                if (response) {
                    this.filterData(response.data);
                    this.dTableData = response.data;
                    this.dTableTotalItems = response.total;
                    this.dTableLoading = false;
                }
            },
            // Prep data for data table
            filterData(data) {
                data.forEach((item) => {
                    let temp_datetime = item.start_time.split(' ');
                    item['start_time'] = this.moment(temp_datetime[0]).format('DD/MM/YYYY');
                    item['start'] = temp_datetime[1].substr(0, 5);
                    temp_datetime = item.end_time.split(' ');
                    item['end'] = temp_datetime[1].substr(0, 5);
                });
            },
            // If data table options have been changed request API for fresh data
            optionsChanged(options) {
                let options_changed = false;
                this.dTableLoading = true;

                // Check if options changed
                for (let prop in this.dTableOptions) {
                    if (this.dTableOptions[prop] !== options[prop]) {
                        options_changed = true;
                        break;
                    }
                }

                if (options_changed) {
                    this.dTableOptions = Object.assign({}, options);
                    this.fetchTableData();
                }
            },
            // Triggered when delete item button is pressed
            deleteItemTrigger(item) {
                this.confirmDialog = true;
                this.confirmDialogClass = 'fail';
                this.confirmDialogHeader = this.$t(`confirmation.work_hours_deletion`);
                this.confirmDialogMessage = this.$t(`confirmation.work_hours_deletion_text`);
                this.confirm_action = 'delete';
                this.current_item_id = item.id;
            },
            // Triggered when deletion of item is confirmed and requests API to actually delete it.
            async deleteItemConfirmed() {
                let response = await this.$store.dispatch('sendData', {
                    method: 'delete',
                    url: `/api/work-hours/${this.current_item_id}`,
                });

                if (response.status === 200) {
                    // Find index of item in table and remove item
                    let deletedItemIndex = this.dTableData.findIndex((item) => {
                        return item.id === this.current_item_id;
                    });
                    this.dTableData.splice(deletedItemIndex, 1);
                    this.fetchTableData();
                }

                this.closeConfirmDialog();
            },
            // Trigger edit item action
            editItemTrigger(item) {
                this.current_item_id = item.id;
                this.$router.push(`/work-hours/edit/${this.current_item_id}`);
            },
            // Trigger repeat item action
            repeatItemTrigger(item) {
                this.current_item_id = item.id;
                this.$router.push(`/work-hours/repeat/${this.current_item_id}`);
            },
            // Close action confirm dialog
            closeConfirmDialog() {
                this.confirmDialog = false;
                this.current_item_id = null;
            },
            // Properly format given time
            formatDate(date) {
                return this.moment(date).format('DD/MM/YYYY');
            },
        },
        async mounted() {
            // Get permissions
            this.update_permission = await this.$store.dispatch('userHasPermission', 'update_work_hours');
            this.delete_permission = await this.$store.dispatch('userHasPermission', 'delete_work_hours');
            this.repeat_permission = await this.$store.dispatch('userHasPermission', 'repeat_work_hours');

            this.getSelectFieldDevelopers();
            this.getSelectFieldClients();
        },
        watch: {
            search_options: {
                deep: true,
                async handler(val) {
                    const temp = Object.assign({}, val);

                    // Reset search criteria
                    this.search_criteria = {};

                    for (let key in temp) {
                        if (temp[key] && key !== 'start_time' && key !== 'end_time') {
                            this.search_criteria[key] = temp[key];
                        }
                    }

                    this.fetchTableData();
                }
            }
        }
    };
</script>
